import React, { useRef } from "react";
import Styles from "./styles.module.scss";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import emailjs from "@emailjs/browser";

const ContactUs = () => {
  const form = useRef();

  const notifySuccess = () =>
    toast.success("Thank you for your interest. We'll reach out to you shortly.", {
      position: "top-center",
      autoClose: 5000,
    });

  const notifyError = () =>
    toast.error("Something went wrong. Please try again.", {
      position: "top-center",
      autoClose: 5000,
    });

  const sendEmail = (e) => {
    e.preventDefault();

    if (!form.current) return;

    emailjs
      .sendForm(
        "service_u2r4q2m",     
        "template_rlhdimw",    
        form.current,          
        "p87NmtLp7L4bobmxM"    
      )
      .then(
        (result) => {
          console.log("Email sent:", result.text);
          notifySuccess();
          form.current.reset(); 
          setTimeout(() => {
            window.location.href = "/";
          }, 8000);
        },
        (error) => {
          console.error("Email error:", error.text);
          notifyError();
        }
      );
  };

  return (
    <form ref={form} onSubmit={sendEmail} className={Styles.formContainer}>
      <ToastContainer />

      {/* First & Last Name */}
      <div className={Styles.contact_form}>
        <div className={Styles.form}>
          <label>First Name*</label>
          <input
            required
            type="text"
            name="user_firstName"
            placeholder="First Name"
            className={Styles.input}
          />
        </div>
        <div className={Styles.form}>
          <label>Last Name*</label>
          <input
            required
            type="text"
            name="user_lastName"
            placeholder="Last Name"
            className={Styles.input}
          />
        </div>
      </div>

      {/* Email & Company Name */}
      <div className={Styles.contact_form}>
        <div className={Styles.form}>
          <label>Email*</label>
          <input
            required
            type="email"
            name="user_email"
            placeholder="Your Email"
            className={Styles.input}
          />
        </div>
        <div className={Styles.form}>
          <label>Company Name*</label>
          <input
            required
            type="text"
            name="user_companyName"
            placeholder="Company Name"
            className={Styles.input}
          />
        </div>
      </div>

      {/* Message */}
      <div className={Styles.contact_form}>
        <div className={Styles.formArea}>
          <label>Tell us about the website you'd like us to build</label>
          <textarea
            required
            name="message"
            placeholder="How can we help you?"
            className={Styles.textarea1}
          ></textarea>
        </div>
      </div>

      {/* Submit */}
      <div>
        <button type="submit" className="btn5 btn-primary1" style={{ border: "none" }}>
          Send Enquiry
        </button>
      </div>
    </form>
  );
};

export default ContactUs;
